// extracted by mini-css-extract-plugin
export default {"rulesButton":"Rules_rulesButton__6PLWF","rulesContainer":"Rules_rulesContainer__OkJfg"};